export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5330.43bcc300.jpg";